import { createIconComponent } from '../../factory/create-icon-component';
export const BulgariaIcon = createIconComponent(
  'BulgariaIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33045)">
      <path d="M23 5H1V20H23V5Z" fill="#496E2D" />
      <path d="M23 5H1V9.99999H23V5Z" fill="#F0F0F0" />
      <path d="M23 15H1V20H23V15Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_10086_33045">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
